<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import {maxLength, minLength, required} from "vuelidate/lib/validators";
import moment from "moment";

/**
 * Invoice-detail component
 */
export default {
    components: { ErrorMessage,Layout, PageHeader },
    data() {
        return {
            errorMessage: "",
            title: "Profile",
            items: [
                {
                    text: "B2c User",
                    href: "/"
                },
                {
                    text: "Profile",
                    active: true
                }
            ],
            errors: null,
            userUuid:"",
            user:"",
            status:"",
            visible:false,
            message:"",
            submitted:false,
            form: {
                first_name: "",
                last_name: "",
                gender:"",
                display_picture:"",
                email:"",
                phone_code:"",
                phone_number:""
            },
        };
    },
    validations: {
        form: {
            first_name: {
                required,
            },
            last_name: {
                required,
            },
            gender:{
                required,
            },
            email:{
                required,
            },
            phone_code: {
                required,
            },
            phone_number: {
                required,
            }
        },
    },
    created() {
        this.userUuid = this.$route.params.id;
    },
    mounted() {
        this.getUserDetail();
    },
    methods: {
        onClose(){
            this.visible=false;
        },
        async getUserDetail() {
            try {
                axios
                    .post("/api/user/b2c/" + this.userUuid, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.form.first_name=response.data.data.first_name;
                            this.form.last_name=response.data.data.last_name;
                            this.form.gender=response.data.data.gender;
                            this.form.display_picture=response.data.data.display_picture;
                            this.form.email=response.data.data.email;
                            this.form.phone_code=response.data.data.phone_code;
                            this.form.phone_number=response.data.data.phone_number;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        onFileChangeProfilePic(e) {
            this.form.display_picture_fileane =
                "Selected File: " + e.target.files[0].name;
            this.form.display_picture = e.target.files[0];
        },
        formSubmit(event) {
            this.submitted = true;
            this.$v.$touch();
            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                    "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                        .content,
                },
            };

            event.preventDefault();
            var self = this;
            var formData = this.gatherFormData();
            axios
                .post("/api/b2c_user/update",formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$refs.profileUpdateForm.reset();
                        this.$swal("Good job!", "ProfileUpdated", "success");
                        this.$router.push({ name: "b2c_user_list" });
                    } else {
                        var str = response.data.message;
                        var jsonParse = JSON.parse(str);
                        this.errorCheck(jsonParse);
                    }
                })
                .catch((error) => {
                    if (error.response != undefined) {
                        this.errors = error.response.data.errors;
                    }
                });
        },
        errorCheck(obj) {
            if(obj.statusCode == 403){
                this.visible=true;
                this.message="Access Permission Denied";
                this.errors = obj.message;
            }else if (obj.error) {
                this.errors = obj.message;
            } else if (obj.message == "Token has expired") {
                this.$swal.fire({
                    title: 'LogOut!',
                    text: 'Token Has Expired',
                    icon: 'error',
                    toast:'true',
                    position: 'top-end',
                });
                this.$router.push({ name: "logout" });
            } else if (
                obj.message !== "Token has expired" &&
                obj.message !== "The given data was invalid."
            ) {
                this.errors = obj.message;
            } else if (obj.message == "The given data was invalid.") {
                this.errors = obj.errors;
            } else {
                this.flashMessage.show({
                    time: 5000,
                    status: "error",
                    title: "Error",
                    message: "Problem in data save",
                });
            }
        },
        gatherFormData() {
            const data = new FormData();
            data.append("accessToken", localStorage.getItem("access_tocken"));
            data.append("first_name", this.form.first_name);
            data.append("last_name", this.form.last_name);
            data.append("gender", this.form.gender);
            data.append("email", this.form.email);
            data.append("display_picture", this.form.display_picture);
            data.append("phone_code", this.form.phone_code);
            data.append("phone_number", this.form.phone_number);
            data.append("user_uuid", this.userUuid);
            return data;
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="font-bold mb-4 ">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <b-form class="needs-validation" ref="profileUpdateForm" @submit.prevent="formSubmit">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="first_name">First Name</label>
                                    <input
                                        id="first_name"
                                        v-model="form.first_name"
                                        name="first_name"
                                        type="text"
                                        class="form-control"
                                        placeholder="Type first name"
                                        value="form.first_name"
                                        :class="{ 'is-invalid': submitted && $v.form.first_name.$error }"
                                    />
                                    <div
                                        v-if="submitted && $v.form.first_name.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.form.first_name.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="last_name">Last Name</label>
                                    <input
                                        id="last_name"
                                        v-model="form.last_name"
                                        name="last_name"
                                        type="text"
                                        class="form-control"
                                        placeholder="Type last name"
                                        value="form.last_name"
                                        :class="{ 'is-invalid': submitted && $v.form.last_name.$error }"
                                    />
                                    <div
                                        v-if="submitted && $v.form.last_name.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.form.last_name.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gender">Gender</label>
                                    <select
                                        id="gender"
                                        name="gender"
                                        v-model="form.gender"
                                        class="form-control"
                                        :class="{ 'is-invalid': submitted && $v.form.gender.$error }">
                                        <option value='male'>Male</option>
                                        <option value='female'>Female</option>
                                    </select>
                                    <div
                                        v-if="submitted && $v.form.gender.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.form.gender.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input
                                        id="email"
                                        v-model="form.email"
                                        name="email"
                                        type="text"
                                        class="form-control"
                                        placeholder="Type Email"
                                        value="form.last_name"
                                        :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                                    />
                                    <div
                                        v-if="submitted && $v.form.email.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.form.email.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone-code">Phone Code</label>
                                    <input
                                        id="phone-code"
                                        v-model="form.phone_code"
                                        name="phone-code"
                                        type="text"
                                        class="form-control"
                                        placeholder="Type Phone Code"
                                        value="form.phone_code"
                                        :class="{ 'is-invalid': submitted && $v.form.phone_code.$error }"
                                    />
                                    <div
                                        v-if="submitted && $v.form.phone_code.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.form.phone_code.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone">Phone No</label>
                                    <input
                                        id="phone"
                                        v-model="form.phone_number"
                                        name="phone"
                                        type="text"
                                        class="form-control"
                                        placeholder="Type Phone Number"
                                        value="form.phone_number"
                                        :class="{ 'is-invalid': submitted && $v.form.phone_number.$error }"
                                    />
                                    <div
                                        v-if="submitted && $v.form.phone_number.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.form.phone_number.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="col-md-4">-->
<!--                                <img v-bind:src="form.display_picture" alt="no image">-->
<!--                            </div>-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Profile Picture</label>
                                    <div class="custom-file">
                                        <input id="b2c_profile_pic" type="file" ref="b2c_profile_pic" name="b2c_profile_pic" v-on:change="onFileChangeProfilePic($event)" class="custom-file-input" />
                                        <label class="custom-file-label" for="b2c_profile_pic">Image</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                            <button class="btn btn-primary" type="submit">Update</button>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
<style scoped>
table>tr>td{
    width:30%;
    height:45px;
}
</style>

